;(function () {
  'use strict'

  angular.module('contrast.applications').constant('APPLICATION_GRADES', {
    A: 'A',
    B: 'B',
    C: 'C',
    D: 'D',
    F: 'F',
    UNKNOWN: '?'
  })
})()
